export const GP_GW_REFFERER = "gw-referrer";

export const OSEID = "oseid";
